import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userInfo: any = null;

  constructor(private http: HttpClient) {}

  getUserInfo(): any {
    if (!this.userInfo) {
      const storedData = localStorage.getItem('userinfo');

      if (storedData) {
        this.userInfo = JSON.parse(storedData);
      }
    }

    return this.userInfo && this.userInfo[environment.customer] && this.userInfo[environment.customer]?.length > 0 ? this.userInfo[environment.customer][0]?.filterOptionsGroup?.name : '';
  }

  getUserFilterName(): string {
    if (!this.userInfo) {
      const storedData = localStorage.getItem('userinfo');

      if (storedData) {
        this.userInfo = JSON.parse(storedData);
      }
    }

    const userInfo = this.userInfo && this.userInfo[environment.customer] && this.userInfo[environment.customer]?.length > 0 ? this.userInfo[environment.customer][0] : {};
    const groupName = userInfo?.filterOptionsGroup?.name?.replace(/ /g, '_');
    const userName  = this.extractUsername(userInfo.email);

    return `${groupName}_${userName}`;
  }

  private extractUsername(email: string) {
    return email?.length > 0 ? email.split('@')[0] : 0;
  }

  GetUsers(page: string)
  {
    let queryUrl = environment.hygraphGetUsers + "?page=" + page;
    let httpOptions: Object = {
    headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
    responseType: 'text'
    }

    return new Promise((resolve, reject) => {
        this.http.get<any>(queryUrl, httpOptions)
          .subscribe(
            response => {
            const users = [];
            let res = JSON.parse(response);
            res.data[environment.customer].forEach(user => {
                users.push({
                name: user.email.split('@')[0],
                displayName: this.capitalizeEachWord(this.getDisplayName(user.email)),
                email: user.email,
                commentGroups: user.commentGroups
                })
            });
              resolve(users);
            },
            error => {
              console.log('error', error);
              reject(error);
            }
          )
      });
  }

  capitalizeEachWord(name: string) 
  {
    return name.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  getDisplayName(email) 
  {
    return this.capitalizeEachWord(email.split('@')[0].replaceAll('.', ' '));
  }
}
